import { action } from 'mobx';
import { BaseListViewStore, UsernameCellData, DateTimeCellData, HistoryPropertyCellData } from 'core/stores';
import { TableMethodInject } from 'core/components';
import { historyLogSource } from 'common/constants';
import { translate } from 'core/utils';
import { FulfillmentOrderStore } from 'modules/order/stores';
import _ from 'lodash';

class FulfillmentOrderHistoryLogViewStore extends BaseListViewStore {
	constructor(rootStore) {
		super(rootStore, {
			listStore: new FulfillmentOrderStore(rootStore),
			queryParams: { embed: ['user', 'fulfillmentOrder'] },
			findFunction: 'findFulfillmentOrderHistoryLog',
			routes: {
				list: () => this.rootStore.routerStore.goTo('master.app.main.order.list'),
			},
			tableData: {
				columns: [
					{
						key: 'user.displayName',
						dataCell: UsernameCellData,
						title: 'FULFILLMENTORDERVIEW.HISTORYLOG.LIST.UPDATEDBY',
						width: 100,
						sortable: false,
					},
					{
						key: 'dateCreated',
						title: 'FULFILLMENTORDERVIEW.HISTORYLOG.LIST.DATECREATED',
						dataCell: DateTimeCellData,
						sortable: false,
						dateFormat: 'LLL',
						useLocalTime: true,
					},
					{
						key: 'userAction',
						title: 'FULFILLMENTORDERVIEW.HISTORYLOG.LIST.USERACTION',
						row: TableMethodInject,
						sortable: false,
						width: 150,
						extra: ({ item, column }) => translate('FULFILLMENTORDERVIEW.HISTORYLOG.LIST.ACTIONS.' + item[column.key]),
					},
					{
						key: 'name',
						title: 'FULFILLMENTORDERVIEW.HISTORYLOG.LIST.PROPERTY',
						dataCell: HistoryPropertyCellData,
						sortable: false,
						width: 300,
					},
					{
						key: 'initialValue',
						title: 'FULFILLMENTORDERVIEW.HISTORYLOG.LIST.OLDVALUE',
						dataCell: HistoryPropertyCellData,
						sortable: false,
						width: 200,
					},
					{
						key: 'newValue',
						title: 'FULFILLMENTORDERVIEW.HISTORYLOG.LIST.NEWVALUE',
						dataCell: HistoryPropertyCellData,
						sortable: false,
						width: 200,
					},
				],
				actions: {},
				sortObject: [],
			},
		});
		this.queryUtility.initialize(this.findFulfillmentOrderHistoryLog);
	}

	findUserAction(userAction) {
		switch (userAction) {
			case 1:
				return 'Create';
				break;
			case 2:
				return 'Update';
				break;
			case 3:
				return 'Delete';
				break;
			default:
				return '';
				break;
		}
	}

	openDetailPage = id => {
		this.rootStore.routerStore.goTo('master.app.main.order.list.detail', {
			id,
		});
	};

	@action.bound async findFulfillmentOrderHistoryLog() {
		this.suspend();
		let filter = this.queryUtility.filter;
		filter.source = String(historyLogSource.fulfillmentOrder);
		if (this.rootStore.routerStore.routerState.params.id) {
			filter.itemId = String(this.rootStore.routerStore.routerState.params.id);
		}
		if (filter.orderBy === null && filter.orderDirection === null) {
			filter.orderBy = 'dateCreated';
			filter.orderDirection = 'desc';
		}
		await this.listStore.findFulfillmentOrderHistoryLog(filter);
		if (this.listStore.response.item.length === 0 && this.listStore.response.page !== 1) {
			await this.queryUtility.changePage(1);
		}
		this.queryUtility.handleResponse(this.listStore.response);
		// When history log data is rendered, go back to previous route (reset to initial route when modal was opened).
		this.rootStore.historyAdapter.goBack();
		this.resume();
	}
}

export default FulfillmentOrderHistoryLogViewStore;



// WEBPACK FOOTER //
// ./src/modules/order/stores/FulfillmentOrderHistoryLogViewStore.js